/* eslint-disable react-hooks/rules-of-hooks */
import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import axios from "axios";
import { z } from "zod";

export const AddSubCategorySchema = z.object({
  name: z.string().min(3),
  description: z.string().min(3),
  category: z.string().min(3),
  company: z.string().min(3),
});

export type AddSubCategorySchemaType = z.infer<typeof AddSubCategorySchema>;

export async function addSubCategory(formData: AddSubCategorySchemaType) {
  try {
    const response = await axiosInstance.post(
      `${config.apiUrl}/sub-categories`,
      formData
    );
    return response.data.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Axios error:", error.response?.data);
    } else {
      console.error("Unknown error:", error);
    }
    throw error;
  }
}
